export default function IMHero() {
  const base = import.meta.env.BASE_URL;
  return (
    <section className="relative overflow-hidden" style={{ background: "linear-gradient(135deg, #0a1e3a 0%, #0d2a4a 50%, #0a2440 100%)", minHeight: 560 }}>
      {/* Background image */}
      <div className="absolute inset-0 opacity-25">
        <img
          src={`${base}images/investment-management/hero-bg.jpg`}
          alt="招商管理背景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a1e3a]/90 via-[#0a1e3a]/60 to-transparent"></div>
      <div className="absolute inset-0 opacity-10"
        style={{ backgroundImage: "linear-gradient(rgba(100,200,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(100,200,255,0.3) 1px, transparent 1px)", backgroundSize: "48px 48px" }}>
      </div>

      <div className="relative max-w-7xl mx-auto px-8 pt-20 pb-24 flex items-center gap-14">
        {/* Left content */}
        <div className="flex-1 min-w-0">
          <div className="inline-flex items-center gap-2 bg-blue-400/10 border border-blue-400/30 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-building-line text-blue-300 text-sm"></i>
            <span className="text-blue-300 text-xs font-medium tracking-wide">数据驱动招商 · 智能匹配供需 · 提升落地效率</span>
          </div>
          <h1 className="text-4xl font-bold text-white leading-tight mb-3">
            招商管理
            <span className="block text-xl font-normal text-blue-300 mt-2">Investment Attraction & Enterprise Service</span>
          </h1>
          <p className="text-blue-100/80 text-sm leading-relaxed mb-6 max-w-lg">
            以空间数据驱动招商，覆盖线索挖掘、项目评估、跟踪闭环、动态监测、风险预警、闭环处置六大核心环节，为开发区、产业园区与地方政府提供全生命周期数字化招商管理，精准匹配企业需求与园区供给。
          </p>

          {/* Pipeline steps */}
          <div className="flex items-center gap-0 mb-8">
            {[
              { num: "1", label: "招商线索" },
              { num: "2", label: "项目评估" },
              { num: "3", label: "落地跟踪" },
            ].map((step, i) => (
              <div key={step.label} className="flex items-center">
                <div className="flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5">
                  <span className="w-5 h-5 rounded-full bg-blue-400/20 border border-blue-400/40 flex items-center justify-center text-blue-300 text-xs font-bold">{step.num}</span>
                  <span className="text-white/90 text-xs">{step.label}</span>
                </div>
                {i < 2 && <i className="ri-arrow-right-s-line text-blue-400/60 text-lg mx-1"></i>}
              </div>
            ))}
          </div>

          {/* Target customers */}
          <div className="flex items-center gap-2 mb-8">
            <span className="text-white/50 text-xs">面向客户：</span>
            {["开发区", "产业园区", "地方政府", "招商局"].map((c) => (
              <span key={c} className="text-xs bg-blue-400/15 border border-blue-400/25 text-blue-200 px-2.5 py-1 rounded-md">{c}</span>
            ))}
          </div>

          <div className="flex items-center gap-4">
            <button className="bg-blue-400 hover:bg-blue-300 text-[#0a1e3a] font-semibold px-7 py-2.5 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap">
              申请试点方案
            </button>
            <button className="border border-white/30 hover:border-white/60 text-white px-7 py-2.5 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-play-circle-line"></i>查看演示
            </button>
          </div>
        </div>

        {/* Right: Dashboard preview */}
        <div className="flex-shrink-0 w-[500px]">
          <div className="bg-[#0a1a3a]/80 backdrop-blur-sm border border-white/15 rounded-2xl overflow-hidden">
            {/* App bar */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 bg-white/5">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-rose-400"></div>
                <div className="w-2 h-2 rounded-full bg-amber-400"></div>
                <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
              </div>
              <span className="text-white/60 text-xs">招商管理平台 · 项目全生命周期</span>
              <span className="text-blue-300 text-xs bg-blue-400/10 px-2 py-0.5 rounded-full">实时监控</span>
            </div>
            {/* Preview image with overlay badges */}
            <div className="relative">
              <img
                src={`${base}images/investment-management/dashboard-preview.png`}
                alt="招商管理面板"
                className="w-full h-56 object-cover object-top"
              />
              {/* Overlay badges */}
              <div className="absolute top-3 left-3 bg-[#0a1a3a]/90 border border-white/15 rounded-lg px-3 py-2">
                <div className="text-xs text-white/60 mb-0.5">在谈项目</div>
                <div className="text-lg font-bold text-blue-300">128 个</div>
              </div>
              <div className="absolute top-3 right-3 bg-[#0a1a3a]/90 border border-blue-400/30 rounded-lg px-3 py-2">
                <div className="text-xs text-blue-300 font-semibold">平均匹配度</div>
                <div className="text-base font-bold text-blue-300">86 分</div>
              </div>
              {/* Pipeline stage tags on image */}
              <div className="absolute bottom-3 left-3 flex gap-2">
                {["线索", "洽谈", "签约", "投产"].map((tag) => (
                  <span key={tag} className="text-xs border border-white/20 bg-[#0a1a3a]/80 text-white/80 px-2.5 py-1 rounded-full">
                    <i className="ri-checkbox-circle-line text-blue-300 text-xs mr-1"></i>{tag}
                  </span>
                ))}
              </div>
            </div>
            {/* Bottom stats */}
            <div className="grid grid-cols-4 gap-0 border-t border-white/10">
              {[
                { label: "新增线索", value: "23", color: "text-blue-300" },
                { label: "评估中", value: "8", color: "text-amber-300" },
                { label: "本月签约", value: "12", color: "text-emerald-300" },
                { label: "待落地", value: "7", color: "text-rose-300" },
              ].map((s) => (
                <div key={s.label} className="px-3 py-3 text-center border-r border-white/10 last:border-0">
                  <div className={`text-sm font-bold ${s.color}`}>{s.value}</div>
                  <div className="text-white/40 text-xs mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
